import { createEvent, createStore, sample } from 'effector';
import { createGate } from 'effector-react';
import { $userAccessToken } from 'src/entity/User';
import { getCurrentUserStatusFx } from '../lib/effects/getCurrentUserStatusFx/getCurrentUserStatusFx';
import { getImageListFx } from '../lib/effects/getImageListFx/getImageListFx';
import { IImageStatus } from './types';

// TODO: добавить обработку ошибок

export const HeroesVkStatusGate = createGate();

export const $heroesVkStatus = createStore<IImageStatus[] | null>(null);
export const $currentHeroesVkStatus = createStore<IImageStatus | null>(null);

export const getCurrentUserStatusFxTrigger = createEvent();

sample({
  clock: [HeroesVkStatusGate.open, $userAccessToken],
  source: { isOpen: HeroesVkStatusGate.status, $userAccessToken },
  filter: ({ isOpen, $userAccessToken }) => !!$userAccessToken && isOpen,
  fn: ({ $userAccessToken }) => $userAccessToken!,
  target: [getImageListFx, getCurrentUserStatusFx]
});

sample({
  clock: getImageListFx.doneData,
  fn: ({ items }) => items,
  target: $heroesVkStatus
});

sample({
  clock: getCurrentUserStatusFxTrigger,
  source: $userAccessToken,
  filter: $userAccessToken => !!$userAccessToken,
  fn: $userAccessToken => $userAccessToken!,
  target: getCurrentUserStatusFx
});

sample({
  clock: getCurrentUserStatusFx.doneData,
  target: $currentHeroesVkStatus
});
